export default __webpack_public_path__ + "static/media/reunion22_w640.7abf077d.jpg";